import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { Web3Provider } from "./components/providers";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Web3Provider>
    <App />
  </Web3Provider>
);
